import Swiper from "swiper";

export const SwiperFotos = () => {

	const sliders = document.querySelectorAll(".swiper-fotos");
	let i = 0;

	sliders.forEach((slider) => {

		const swiper = new Swiper(slider, {
			// loop: true,
			slidesPerView: 1,
			observer: true,
			speed: 1200,
			observeParents: true,
			spaceBetween: 40,
		});


		const prevBtn = document.getElementById("swiper-fotos-prev-" + i);
		const nextBtn = document.getElementById("swiper-fotos-next-" + i);

		// // Add disabled ao btn quando preciso
		const updateNavButtons = () => {
			if (swiper.isBeginning) {
				prevBtn.disabled = true;
			} else {
				prevBtn.disabled = false;
			}

			if (swiper.isEnd) {
				nextBtn.disabled = true;
			} else {
				nextBtn.disabled = false;
			}
		};

		prevBtn.addEventListener("click", () => {
			swiper.slidePrev();
			updateNavButtons();
		});

		nextBtn.addEventListener("click", () => {
			swiper.slideNext();
			updateNavButtons();
		});

		updateNavButtons();

		i++;
	});

};